import { render, staticRenderFns } from "./langSwitch.vue?vue&type=template&id=25df17a5&scoped=true"
import script from "./langSwitch.vue?vue&type=script&lang=js"
export * from "./langSwitch.vue?vue&type=script&lang=js"
import style0 from "./langSwitch.vue?vue&type=style&index=0&id=25df17a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25df17a5",
  null
  
)

export default component.exports